<template>
  <div class="row">
    <!--  导师提供课程列表  -->
    <div class="flex xs12">
      <va-card :title="title">
        <div class="row align-center mb-1">
          <div class="flex xs12">
            <!--   课程类型筛选       -->
            <va-button-group>
              <va-button class="mb-2" flat disabled color="gray">课程类型：</va-button>
              <va-button class="mb-2" flat :color="computeServiceType(null)" v-on:click="handleServiceTypeChange(null)" >全部</va-button>
              <va-button
                class="mb-2"
                v-for="serviceType in offeredServiceTypes"
                :key="serviceType.CODE"
                :color="computeServiceType(serviceType.CODE)"
                flat
                v-on:click="handleServiceTypeChange(serviceType.CODE)"
              >{{serviceType.TEXT}}</va-button>
            </va-button-group>
            <va-button-group>
              <va-button disabled flat color="gray" >处理状态：</va-button>
              <va-button :color="computeAuditStatusColor(null)" flat  v-on:click="handleAuditStatusChange(null)" >全部</va-button>
              <va-button
                class="mb-2"
                v-for="auditStatus in auditStatusTypes"
                :key="auditStatus.CODE"
                :color="computeAuditStatusColor(auditStatus.CODE)"
                flat
                v-on:click="handleAuditStatusChange(auditStatus.CODE)"
              >{{auditStatus.TEXT}}</va-button>
            </va-button-group>
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <!--    导师uid筛选      -->
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="mentorUid"
              placeholder="搜索导师ID"
              @input="searchMentorUid"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <!--    课程id筛选      -->
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              v-show="!!serviceType"
              :value="serviceId"
              placeholder="搜索课程ID"
              @input="searchServiceId"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="offeredCourses"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listOfferedCourse"
          api-mode
        >
          <template slot="mentor" slot-scope="props">
            <va-button color="gray" flat small :to='{path:`/admin/mentors/getMentor/${props.rowData.mentor.uid}`}'>
              {{ props.rowData.mentor.nickname }}
            </va-button>
          </template>
          <template slot="serviceType" slot-scope="props">
            <va-badge color="info">
              {{ computeCodeToServiceType(props.rowData.serviceType) }}
            </va-badge>
          </template>
          <template slot="auditStatus" slot-scope="props">
            <va-badge color= 'info'>
              {{ computeAuditStatus(props.rowData.auditStatus).text }}
            </va-badge>
          </template>
          <template slot="course" slot-scope="props">
            <va-button color= 'gray' flat small :to='{path: `/admin/services/${computeCoursePath(props.rowData.course.id, props.rowData.serviceType)}/${props.rowData.course.id}`}'>
              {{ props.rowData.course.name }}
            </va-button>
          </template>
        </va-data-table>

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'

import offeredCourseApi from '../../api/offerCourse'
import {
  OFFERED_SERVICE_TYPES,
  SERVICE_AUDIT_TYPE,
} from '../../utils/constants'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      offeredCourses: [],
      name: '',
      loading: true,
      pageNumber: 1,
      totalCount: 0,
      pageSize: 10,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
      statusOptions: [],
      mentorUid: this.$route.query.mentorUid,
      auditStatus: null,
      serviceId: null,
      serviceType: null,
      auditStatusTypes: SERVICE_AUDIT_TYPE,
      title: '导师提供的课程',
      offeredServiceTypes: OFFERED_SERVICE_TYPES,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'mentor.uid',
          title: '导师uid',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:mentor',
          title: '导师姓名',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:serviceType',
          title: '课程类型',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:course',
          title: '课程名称',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:auditStatus',
          title: '导师申请加入课程审核状态',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listOfferedCourse()
  },
  methods: {
    listOfferedCourse (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageNumber: pageNumber,
        pageSize: this.pageSize,
        auditStatus: this.auditStatus,
        mentorUid: this.mentorUid,
        serviceId: this.serviceId,
        serviceType: this.serviceType,
      }
      offeredCourseApi.listOfferedCourse(params).then(response => {
        this.offeredCourses = response.offeredCourses
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => alert(error.msg))
    },
    search: debounce(function (name) {
      this.name = name
    }, 400),
    computeAuditStatus (auditStatus) {
      const data = {
        text: '',
      }
      SERVICE_AUDIT_TYPE.map(x => {
        if (auditStatus === x.CODE) {
          data.text = x.TEXT
        }
      })
      return data
    },
    computeAuditStatusColor (auditStatus) {
      return this.auditStatus === auditStatus ? 'info' : 'gray'
    },
    handleAuditStatusChange (auditStatus) {
      this.auditStatus = auditStatus
      this.listOfferedCourse()
    },
    computeCoursePath (serviceId, serviceType) {
      let path = ''
      this.offeredServiceTypes.map(x => {
        if (x.CODE === serviceType) {
          path = x.COURSE_PATH
        }
      })
      return path
    },
    computeServiceType (serviceType) {
      return serviceType === this.serviceType ? 'info' : 'gray'
    },
    handleServiceTypeChange (serviceType) {
      this.serviceType = serviceType
      this.listOfferedCourse()
    },
    computeCodeToServiceType (code) {
      let serviceType = ''
      this.offeredServiceTypes.map(x => {
        if (x.CODE === code) {
          serviceType = x.TEXT
        }
      })
      return serviceType
    },
    searchServiceId: debounce(function (serviceId) {
      this.serviceId = serviceId
      if (this.serviceId === '') { this.serviceId = null }
      this.listOfferedCourse()
    }, 400),
    searchMentorUid: debounce(function (mentorUid) {
      this.mentorUid = mentorUid
      if (this.mentorUid === '') { this.mentorUid = null }
      this.listOfferedCourse()
    }, 400),
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
